import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/features';
import { ResortErrorType } from 'src/features/resort';
import { RequestState } from 'src/features/utils/RequestState';
import { UserResortProfile } from 'src/models/resort/UserResortProfile';

interface DeepLinkContent {
  profile: UserResortProfile;
  isMyself: boolean;
  isFollowing: boolean;
}

export const resortDeepLinkContentSelector = createSelector(
  [
    (state: RootState) => state.resort.displayedUserProfile,
    (state: RootState) => state.resort.followList,
    (state: RootState) => state.user.selectedUserId
  ],
  (
    profile,
    followList,
    selectedUserId
  ): RequestState<DeepLinkContent, ResortErrorType> | undefined => {
    if (profile?.state === 'error') {
      return { state: 'error', error: profile.error };
    }
    if (followList?.state === 'error') {
      return { state: 'error', error: followList.error };
    }
    if (profile?.state === 'pending' || followList?.state === 'pending') {
      return { state: 'pending' };
    }
    if (profile?.state === 'ok' && followList?.state === 'ok') {
      const isMyself = selectedUserId === profile.result.id;
      const isFollowing =
        followList.result.find(user => user.resortPlannerId === profile.result.resortPlannerId) !==
        undefined;
      return {
        state: 'ok',
        result: { profile: profile.result, isMyself, isFollowing }
      };
    }
    return undefined;
  }
);
